import api from '@/lib/axios'

export interface TemplateFieldDef {
  name: string
  display_name?: string | null
  description?: string | null
  field_type: string
  extraction_prompt?: string | null
  is_required?: boolean
  is_line_item?: boolean
  sort_order?: number
}

export interface FieldTemplate {
  id: string
  org_id: string | null
  name: string
  slug: string
  description: string | null
  category: string | null
  icon: string | null
  is_system: boolean
  fields: TemplateFieldDef[]
  project_system_prompt: string | null
  created_by: string | null
  created_at: string
}

export interface ApplyTemplateResponse {
  template_id: string
  template_name: string
  fields_added: number
  replaced_existing: boolean
}

export const fieldTemplatesApi = {
  list: () =>
    api.get<FieldTemplate[]>('/field-templates').then((r) => r.data),

  get: (id: string) =>
    api.get<FieldTemplate>(`/field-templates/${id}`).then((r) => r.data),

  create: (data: {
    name: string
    description?: string
    category?: string
    icon?: string
    fields: TemplateFieldDef[]
    project_system_prompt?: string
  }) => api.post<FieldTemplate>('/field-templates', data).then((r) => r.data),

  update: (id: string, data: Partial<{
    name: string
    description: string
    category: string
    icon: string
    fields: TemplateFieldDef[]
    project_system_prompt: string
  }>) => api.patch<FieldTemplate>(`/field-templates/${id}`, data).then((r) => r.data),

  delete: (id: string) =>
    api.delete(`/field-templates/${id}`).then((r) => r.data),

  duplicate: (id: string) =>
    api.post<FieldTemplate>(`/field-templates/${id}/duplicate`).then((r) => r.data),

  applyToProject: (projectId: string, templateId: string, replaceExisting = false) =>
    api
      .post<ApplyTemplateResponse>(`/projects/${projectId}/apply-template`, {
        template_id: templateId,
        replace_existing: replaceExisting,
      })
      .then((r) => r.data),

  saveAsTemplate: (projectId: string, data: { name: string; description?: string; category?: string; icon?: string }) =>
    api
      .post<FieldTemplate>(`/projects/${projectId}/save-as-template`, data)
      .then((r) => r.data),
}
